module.exports = __webpack_public_path__ + "static/media/logo.9dceb476.svg";